<template>
  <fin-data-loader ref="profileLoader" :resolver="fetchData" fullpage>
    <template #content>
      <div>
        <v-row v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
          <v-col cols="12">
            <fin-profile-portrait :companyPortrait="companyPortrait"/>
          </v-col>
        </v-row>
        <v-row v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
               class="pt-8"
               style="background-color: white">
          <v-col cols="12" md="6">
            <fin-corporate-calendar :calendarItems="calendarItems"></fin-corporate-calendar>
          </v-col>
          <v-col :class="$vuetify.breakpoint.mdAndUp ? 'pl-12 pr-4' : ''" cols="12" md="6">
            <fin-elevated-box :class="$vuetify.breakpoint.mdAndUp ? 'ml-12' : ''" :padding-px="6" :padding-py="4"
                              hard-shadow>
              <span class="headline-section">Hauptaktionäre</span>
              <fin-chart2 v-if="majorShareholdersChartOptions.series[0].data" :options="majorShareholdersChartOptions"
                          constructor-type="chart"/>
              <p v-else>Keine Daten verfügbar</p>
            </fin-elevated-box>
          </v-col>
        </v-row>
        <v-row v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
               class="py-8"
               style="background-color: white">
          <v-col class="pt-8" cols="12" style="border-top: 1px solid #e0e2e3">
            <fin-company-more-information :companyPortrait="companyPortrait"/>
          </v-col>
        </v-row>
      </div>
    </template>
  </fin-data-loader>
</template>

<script>
import FinProfilePortrait from "@/components/pages/finCompanyPage/profile/Portrait"
import {finCompanyAPI} from "@/js/finAPI"
import FinDataLoader from "@/components/common/DataLoader"
import FinElevatedBox from "@/components/common/box/elevatedBox"
import FinCorporateCalendar from "@/components/pages/finCompanyPage/profile/CorporateCalendar"
import FinCompanyMoreInformation from "@/components/pages/finCompanyPage/profile/MoreInformation"
import FinChart2 from "@/components/common/Chart2/FinChart2"

export default {
  name: 'finCompanyPageProfile',
  components: {
    FinChart2,
    FinCompanyMoreInformation,
    FinElevatedBox,
    FinDataLoader,
    FinCorporateCalendar,
    FinProfilePortrait
  },
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      companyPortrait: {},
      calendarItems: [],
      majorShareholdersChartOptions: {},
    }
  },
  methods: {
    async fetchData() {
      this.companyPortrait = await finCompanyAPI.getCompany(this.id)
      this.calendarItems = this.companyPortrait?.events.items

      const seriesData = this.companyPortrait?.shareholders ?
        this.companyPortrait.shareholders.map((obj) => {
          return Object.values(obj)
        }) : (this.companyPortrait?.shareholders && this.companyPortrait?.shareholders.length === 0 ? [] : undefined)

      this.majorShareholdersChartOptions = {
        chart: {
          type: "pie",
        },
        series: [
          {
            data: seriesData
          }
        ],
        preset: 'autoGroupPie',
        presetData: {
          freeFloat: 100,
          partition: {
            type: 'percent',
            value: 2,
          },
        },
      }
      console.log("majorShareholdersChartOptions", this.majorShareholdersChartOptions)
    }
  },
  watch: {
    id() {
      // url param id changes e.g. because of search -> reload page data
      this.$refs.profileLoader._fetchData()
    },
  },
}
</script>

<style lang="scss" scoped>

.col {
  padding-top: 0;
}

</style>
